tinymce.addI18n("sr", {
    "#": "",
    "Accessibility": "",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Akcija",
    "Activity": "",
    "Address": "Adresa",
    "Advanced": "Napredno",
    "Align": "Poravnaj",
    "Align center": "Poravnano centar",
    "Align left": "Poravnano levo",
    "Align right": "Poravnano  desno",
    "Alignment": "Svrstavanje",
    "Alignment {0}": "",
    "All": "",
    "Alternative description": "",
    "Alternative source": "Alternativni izvor",
    "Alternative source URL": "Alternativni izvorni URL",
    "Anchor": "",
    "Anchor...": "Sidro",
    "Anchors": "sidro",
    "Animals and Nature": "",
    "Arrows": "",
    "B": "",
    "Background color": "Boja pozadine",
    "Background color {0}": "",
    "Black": "",
    "Block": "Blok",
    "Block {0}": "",
    "Blockquote": "Navodnici",
    "Blocks": "Blokovi",
    "Blue": "",
    "Blue component": "",
    "Body": "Telo",
    "Bold": "Podebljan",
    "Border": "Okvir",
    "Border color": "Boja ivice",
    "Border style": "Stil okvira",
    "Border width": "\u0160irina okvira",
    "Bottom": "Podno\u017eje",
    "Browse files": "",
    "Browse for an image": "Prona\u0111i sliku",
    "Browse links": "",
    "Bullet list": "Lista nabrajanja",
    "Cancel": "Opozovi",
    "Caption": "Natpis",
    "Cell": "\u0106elija",
    "Cell padding": "Razmak \u0107elije",
    "Cell properties": "Postavke \u0107elije",
    "Cell spacing": "Prostor \u0107elije",
    "Cell styles": "",
    "Cell type": "Tip \u0107elije",
    "Center": "Centar",
    "Characters": "",
    "Characters (no spaces)": "",
    "Circle": "Krug",
    "Class": "Klasa",
    "Clear formatting": "Brisanje formatiranja",
    "Close": "Zatvori",
    "Code": "Kod",
    "Code sample...": "Primer koda",
    "Code view": "",
    "Color Picker": "Odabir boje",
    "Color swatch": "",
    "Cols": "Kolone",
    "Column": "Kolona",
    "Column clipboard actions": "",
    "Column group": "Grupa kolone",
    "Column header": "",
    "Constrain proportions": "Ograni\u010dene proporcije",
    "Copy": "Kopiraj",
    "Copy column": "",
    "Copy row": "Kopiraj red",
    "Could not find the specified string.": "Nije mogu\u0107e prona\u0107i navedeni niz.",
    "Could not load emojis": "",
    "Count": "Ra\u010dunati",
    "Currency": "",
    "Current window": "Istom prozoru",
    "Custom color": "Posebna boja",
    "Custom...": "Posebno...",
    "Cut": "Iseci",
    "Cut column": "",
    "Cut row": "Iseci red",
    "Dark Blue": "",
    "Dark Gray": "",
    "Dark Green": "",
    "Dark Orange": "",
    "Dark Purple": "",
    "Dark Red": "",
    "Dark Turquoise": "",
    "Dark Yellow": "",
    "Dashed": "",
    "Date/time": "Datum/vreme",
    "Decrease indent": "Smanji uvla\u010denje",
    "Default": "Podrazumevano",
    "Delete accordion": "",
    "Delete column": "Obri\u0161i kolonu",
    "Delete row": "Obri\u0161i red",
    "Delete table": "Obri\u0161i tabelu",
    "Dimensions": "Dimenzije",
    "Disc": "Disk",
    "Div": "",
    "Document": "Dokument",
    "Dotted": "\u0422\u0430\u0447\u043a\u0430\u0441\u0442\u043e",
    "Double": "",
    "Drop an image here": "Prevuci sliku ovde",
    "Dropped file type is not supported": "",
    "Edit": "Ure\u0111ivanje",
    "Embed": "Ugra\u0111eno",
    "Emojis": "",
    "Emojis...": "",
    "Error": "Gre\u0161ka",
    "Error: Form submit field collision.": "",
    "Error: No form element found.": "",
    "Extended Latin": "",
    "Failed to initialize plugin: {0}": "",
    "Failed to load plugin url: {0}": "",
    "Failed to load plugin: {0} from url {1}": "",
    "Failed to upload image: {0}": "",
    "File": "Datoteka",
    "Find": "Na\u0111i",
    "Find (if searchreplace plugin activated)": "Prona\u0111i (ako je dodatak pretrage i zamene aktiviran)",
    "Find and Replace": "",
    "Find and replace...": "Prona\u0111i i zameni...",
    "Find in selection": "",
    "Find whole words only": "Prona\u0111i samo cele re\u010di",
    "Flags": "",
    "Focus to contextual toolbar": "Fokus na kontekstualnu traku alata",
    "Focus to element path": "Fokus na putanju elementa",
    "Focus to menubar": "Fokus na meni",
    "Focus to toolbar": "Fokus na traku sa alatima",
    "Font": "",
    "Font size {0}": "",
    "Font sizes": "",
    "Font {0}": "",
    "Fonts": "Pisma",
    "Food and Drink": "",
    "Footer": "Podno\u017eje",
    "Format": "",
    "Format {0}": "",
    "Formats": "Formatiraj",
    "Fullscreen": "Pun ekran",
    "G": "",
    "General": "Op\u0161te",
    "Gray": "",
    "Green": "",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Prakti\u010dne pre\u010dice",
    "Header": "Zaglavlje",
    "Header cell": "Visina \u0107elije",
    "Heading 1": "Naslov 1",
    "Heading 2": "Naslov 2",
    "Heading 3": "Naslov 3",
    "Heading 4": "Naslov 4",
    "Heading 5": "Naslov 5",
    "Heading 6": "Naslov 6",
    "Headings": "Naslovi",
    "Height": "Visina",
    "Help": "Pomo\u0107",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "Horizontalna linija",
    "Horizontal space": "Horizontalni razmak",
    "ID": "",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "Image is decorative": "",
    "Image list": "Lista slika",
    "Image title": "Naslov slike",
    "Image...": "Slika...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Pove\u0107aj uvla\u010denje",
    "Inline": "U liniji",
    "Insert": "Umetni",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Ubaci kolonu posle",
    "Insert column before": "Ubaci kolonu pre",
    "Insert date/time": "Ubaci datum/vreme",
    "Insert image": "Ubaci sliku",
    "Insert link (if link plugin activated)": "Dodaj link (ukoliko je link dodatak aktiviran)",
    "Insert row after": "Ubaci red posle",
    "Insert row before": "Ubaci red pre",
    "Insert table": "ubaci tabelu",
    "Insert template...": "Umetni \u0161emu...",
    "Insert video": "Ubaci video",
    "Insert/Edit code sample": "Dodaj/Izmeni primer koda",
    "Insert/edit image": "Ubaci/Promeni sliku",
    "Insert/edit link": "Ubaci/promeni vezu",
    "Insert/edit media": "Ubaci/izmeni mediju",
    "Insert/edit video": "Ubaci/promeni video",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "isko\u0161en",
    "Justify": "Poravnanje",
    "Keyboard Navigation": "",
    "Language": "Jezik",
    "Learn more...": "Saznaj vi\u0161e",
    "Left": "Levo",
    "Left to right": "Sa leve na desnu",
    "Light Blue": "",
    "Light Gray": "",
    "Light Green": "",
    "Light Purple": "",
    "Light Red": "",
    "Light Yellow": "",
    "Line height": "",
    "Link list": "Lista veza",
    "Link...": "Veza...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "Donja Alpha",
    "Lower Greek": "Ni\u017ei gr\u010dki",
    "Lower Roman": "Donji Roman",
    "Match case": "Predmet za upore\u0111ivanje",
    "Mathematical": "",
    "Media poster (Image URL)": "Poster medije (slika URL)",
    "Media...": "Medija...",
    "Medium Blue": "",
    "Medium Gray": "",
    "Medium Purple": "",
    "Merge cells": "Spoji \u0107elije",
    "Middle": "Sredina",
    "Midnight Blue": "",
    "More...": "",
    "Name": "Ime",
    "Navy Blue": "",
    "New document": "Novi dokument",
    "New window": "Novi prozor",
    "Next": "Slede\u0107i",
    "No": "",
    "No alignment": "",
    "No color": "Bez boje",
    "Nonbreaking space": "bez ramaka",
    "None": "Ni\u0161ta",
    "Numbered list": "Numerisana lista",
    "OR": "ili",
    "Objects": "",
    "Ok": "Ok",
    "Open help dialog": "",
    "Open link": "",
    "Open link in...": "Otvori vezu u...",
    "Open popup menu for split buttons": "",
    "Orange": "",
    "Outset": "",
    "Page break": "Lomljenje stranice",
    "Paragraph": "Paragraf",
    "Paste": "Nalepi",
    "Paste as text": "Nalepi kao tekst",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Nalepiti je sada u obi\u010dnom text modu.Sadr\u017eaj \u0107e biti nalepljen kao obi\u010dan tekst dok ne ugasite ovu opciju.",
    "Paste or type a link": "Nalepi ili ukucaj link",
    "Paste row after": "Nalepi red posle",
    "Paste row before": "Nalepi red pre",
    "Paste your embed code below:": "Nalepite ugra\u0111eni kod ispod:",
    "People": "",
    "Plugins": "Dadaci",
    "Plugins installed ({0}):": "Dodataka instalirano ({0}):",
    "Powered by {0}": "Pokre\u0107e ga {0}",
    "Pre": "",
    "Preferences": "",
    "Preformatted": "Formatirano",
    "Premium plugins:": "Premium dodaci",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "Pregled",
    "Previous": "Predhodno",
    "Print": "",
    "Print...": "\u0160tampa...",
    "Purple": "",
    "Quotations": "",
    "R": "",
    "Range 0 to 255": "",
    "Red": "",
    "Red component": "",
    "Redo": "Napred",
    "Remove": "",
    "Remove color": "Ukloni boju",
    "Remove link": "Ukloni link",
    "Replace": "Zameni",
    "Replace all": "Zameni sve",
    "Replace with": "Zameni sa",
    "Resize": "Promeni veli\u010dinu",
    "Restore last draft": "Vrati  poslednji nacrt",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "Podru\u010dje oboga\u0107enog teksta. Pritisnite ALT-0 za pomo\u0107.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Oboga\u0107en tekst. Pritisni te ALT-F9 za meni.Pritisnite ALT-F10 za traku sa alatkama.Pritisnite ALT-0 za pomo\u0107",
    "Ridge": "",
    "Right": "Desno",
    "Right to left": "Sa desne na levu",
    "Row": "Red",
    "Row clipboard actions": "",
    "Row group": "Grupa reda",
    "Row header": "",
    "Row properties": "Postavke reda",
    "Row type": "Tip reda",
    "Rows": "Redovi",
    "Save": "Sa\u010duvati",
    "Save (if save plugin activated)": "Sa\u010duvaj (ukoliko je sa\u010duvaj dodatak aktiviran)",
    "Scope": "Obim",
    "Search": "",
    "Select all": "Obele\u017ei sve",
    "Select...": "",
    "Selection": "Odabiranje",
    "Shortcut": "Pre\u010dica",
    "Show blocks": "Prikaz blokova",
    "Show caption": "Prika\u017ei naslov",
    "Show invisible characters": "Prika\u017ei nevidljive karaktere",
    "Size": "",
    "Solid": "\u041f\u0443\u043d\u043e",
    "Source": "Izvor",
    "Source code": "Izvorni kod",
    "Special Character": "",
    "Special character...": "Specijalan karakter",
    "Split cell": "Razdvoji \u0107elije",
    "Square": "Kvadrat",
    "Start list at number": "",
    "Strikethrough": "Precrtan",
    "Style": "Stil",
    "Subscript": "Potpisan",
    "Superscript": "Natpis",
    "Switch to or from fullscreen mode": "",
    "Symbols": "",
    "System Font": "Sistemski font",
    "Table": "Tabela",
    "Table caption": "",
    "Table properties": "Postavke tabele",
    "Table styles": "",
    "Template": "\u0160ablon",
    "Templates": "\u0160abloni",
    "Text": "",
    "Text color": "Boja tekst",
    "Text color {0}": "",
    "Text to display": "Tekst za prikaz",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Izgleda da je URL koji ste uneli email adresa. Da li \u017eelite da dodate zahtevani mailto: prefiks?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Izgleda da je URL koji ste uneli spolja\u0161nja veza. Da li \u017eelite da dodate zahtevani http:// prefiks?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "",
    "Title": "Naslov",
    "To open the popup, press Shift+Enter": "Da otvorite popup, pritisnite Shift+Enter",
    "Toggle accordion": "",
    "Tools": "Alatke",
    "Top": "Vrh",
    "Travel and Places": "",
    "Turquoise": "",
    "Underline": "Podvu\u010den",
    "Undo": "Nazad",
    "Upload": "Po\u0161alji",
    "Uploading image": "",
    "Upper Alpha": "Gornji Alpha",
    "Upper Roman": "Gornji Roman",
    "Url": "",
    "User Defined": "",
    "Valid": "Ispravno",
    "Version": "",
    "Vertical align": "",
    "Vertical space": "Vertikalni razmak",
    "View": "Prikaz",
    "Visual aids": "Vizuelna pomagala",
    "Warn": "Upozorenje",
    "White": "",
    "Width": "\u0160irina",
    "Word count": "Broja\u010d re\u010di",
    "Words": "Re\u010di",
    "Words: {0}": "Re\u010di:{0}",
    "Yellow": "",
    "Yes": "",
    "You are using {0}": "Koristite {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Imate nesa\u010duvane promene dali ste sigurni da \u017eelite da iza\u0111ete?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Va\u0161 pretra\u017eiva\u010d nepodr\u017eava direktan pristup prenosu.Koristite Ctrl+X/C/V pre\u010dice na tastaturi",
    "alignment": "",
    "austral sign": "",
    "cedi sign": "",
    "colon sign": "",
    "cruzeiro sign": "",
    "currency sign": "",
    "dollar sign": "",
    "dong sign": "",
    "drachma sign": "",
    "euro-currency sign": "",
    "example": "",
    "formatting": "",
    "french franc sign": "",
    "german penny symbol": "",
    "guarani sign": "",
    "history": "",
    "hryvnia sign": "",
    "indentation": "",
    "indian rupee sign": "",
    "kip sign": "",
    "lira sign": "",
    "livre tournois sign": "",
    "manat sign": "",
    "mill sign": "",
    "naira sign": "",
    "new sheqel sign": "",
    "nordic mark sign": "",
    "peseta sign": "",
    "peso sign": "",
    "ruble sign": "",
    "rupee sign": "",
    "spesmilo sign": "",
    "styles": "",
    "tenge sign": "",
    "tugrik sign": "",
    "turkish lira sign": "",
    "won sign": "",
    "yen character": "",
    "yen/yuan character variant one": "",
    "yuan character": "",
    "yuan character, in hong kong and taiwan": "",
    "{0} characters": "",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} re\u010di"
});